import React, { ReactNode, useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getCurrentUserInfo } from '../../services/authService';

interface ProtectedRouteProps {
  children: ReactNode;
}

/**
 * Protected route component
 * Ensures user is authenticated before rendering children
 */
function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { t } = useTranslation();
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const user = await getCurrentUserInfo();
        setIsAuthenticated(!!user);
      } catch (error) {
        console.log('Not authenticated:', error);
        setIsAuthenticated(false);
      }
    };
    checkAuth();
  }, []);

  // Loading state
  if (isAuthenticated === null) {
    return (
      <div className="loading-container">
        <p>{t('chat.loading')}</p>
      </div>
    );
  }

  // Not authenticated - redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Authenticated - render children
  return <>{children}</>;
}

export default ProtectedRoute;
